import React, { useRef } from 'react'
import { DialogOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import SurnameSelectionFormView from '../SurnameSelectionFormView/SurnameSelectionFormView'

export default function SurnameOverlay({ overlay, pageNumber, isGlobalSurnamePage = false }) {
  const [t] = useTranslation()
  const surnameFormRef = useRef()

  return (
    <DialogOverlay
      size="md"
      title={t('LayoutPickerOverlay.surnameSelection.title', 'Surname Infographic')}
      subtitle={t('LayoutPickerOverlay.surnameSelection.subtitle', 'Learn fun facts about a surname')}
      focusRef={surnameFormRef}
      {...overlay}
    >
      <SurnameSelectionFormView
        pageNumber={pageNumber}
        overlay={overlay}
        focusRef={surnameFormRef}
        isGlobalSurnamePage={isGlobalSurnamePage}
      />
    </DialogOverlay>
  )
}
